import React, { Fragment } from "react";
import Seo from "../../components/utils/Seo";
import BaseSecured from "../BaseSecured";
import BodyAdmin from "./BodyAdmin";

const AdminPage = (props) => {
  return (
    <Fragment>
      <Seo
        title="nti / administration"
        description="Administrez votre boutique en ajoutant des nouveaux articles"
      />
      <BaseSecured>
        <BodyAdmin />
      </BaseSecured>
    </Fragment>
  );
};

export default AdminPage;
